import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import MobileQuotesList from "@/components/quotes/MobileQuotesList";
import QuotesTable from "@/components/quotes/QuotesTable";
import { Button } from "@/components/ui/button";
import { TextInput } from "@/components/ui/textInput";
import { Typography } from "@/components/ui/typography";
import useCUCompositeJobStore from "@/store/useCUCompositeJobStore";

export default function Quotes() {
  const navigate = useNavigate();
  const [isDesktopView, setIsDesktopView] = useState(() => {
    if (typeof window === "undefined") return true; // SSR fallback
    return window.innerWidth >= 800;
  });
  const { resetState } = useCUCompositeJobStore();

  const [search, setSearch] = useState("");

  // Handle responsive behavior for 800px breakpoint
  useEffect(() => {
    const handleResize = () => {
      setIsDesktopView(window.innerWidth >= 800);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="relative flex flex-1 flex-col">
      <div className="mb-8 flex flex-wrap items-center md:flex-nowrap">
        <Typography variant="display-lg" weight="semibold">
          Quotes
        </Typography>

        <div className="md:w-inital ml-auto mt-6 flex w-full items-end gap-4 md:mt-0">
          <TextInput
            value={search}
            onChange={(e) => {
              const input = e.target as HTMLInputElement;
              return setSearch(input.value);
            }}
            name="search"
            className="ml-auto w-full md:w-80"
            label="Search"
            placeholder="Search"
          />
          <Button
            className="fixed bottom-1 left-1/2 z-40 translate-x-[-50%] md:static md:translate-x-0"
            size="lg"
            onClick={() => {
              resetState();
              navigate("/quotes/create-edit-custom-quote");
            }}
          >
            Create custom quote
          </Button>
        </div>
      </div>
      {isDesktopView ? <QuotesTable search={search} /> : <MobileQuotesList search={search} />}
    </div>
  );
}
